// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';


const requiredPart = t.interface({
  tag: t.string,
});

export const ValidateBreederBindingManagerBaseObjectSchema = excess(requiredPart);

export interface ValidateBreederBindingManagerBaseObject extends t.TypeOf<typeof ValidateBreederBindingManagerBaseObjectSchema> {}
